import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Stack,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import {
  apiClient,
  getOrgId,
  getRole,
  getToken,
  UserRole,
} from '@devd-client/api';

import { useState } from 'react';
import { useToastHook } from '../appToast/index';
import { Loader } from '../appLoader/index';
import { CrossIcon, TickIcon } from '../icons';
import { useMemo } from 'react';

const HIDDEN_FEATURES = new Set([
  'unlimited contributors',
  'up to 50 contributors',
  'download data',
]);

// interface SubsPlanCardProps {
//   currentPlan: boolean;
//   planName: string;
//   planDesc: string;
//   showUpgradeNow: boolean;
// }

export const SubsPlanCard = ({
  item,
  currentPlan,
  handleTalkToSales,
  email,
}: any) => {
  const [newToast] = useToastHook();
  const [loading, setLoading] = useState(false);
  const isEnterprisePlan =
    (item?.title as string | undefined)?.toLowerCase?.() === 'enterprise';
  const filteredFeatures = useMemo(() => {
    const features = item?.features as Array<any> | undefined;
    if (!features?.length) return [];

    return features.filter((el) => {
      const title = (el?.title as string | undefined)
        ?.toLowerCase?.()
        ?.trim?.();
      return title ? !HIDDEN_FEATURES.has(title) : true;
    });
  }, [item?.features]);

  const handleTalkToSalesClick = () => {
    try {
      window.open(
        'https://calendly.com/devdynamics/30min',
        '_blank',
        'noopener,noreferrer'
      );
    } catch (e: any) {
      newToast({ status: 'error', message: 'Unable to open Calendly link.' });
    }
  };

  const handleStripeCheckout = () => {
    setLoading(true);
    apiClient(`/v1/billing/session`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify({
        orgId: getOrgId(),
        planKey: item?.key,
      }),
    })
      .then((res: any) => {
        window.location.assign(res.dto);
        setLoading(true);
      })
      .catch((err: any) => {
        newToast({ status: 'error', message: err.message });
        setLoading(false);
      });
  };

  const isAdmin =
    getRole() === UserRole.EMPLOYER_ADMIN || getRole() === UserRole.SUPPORT;
  const tooltipLabel = !isAdmin ? 'Not allowed for this role.' : '';

  return (
    <Stack
      borderRadius="4px"
      border="0.5px solid rgba(0, 0, 0, 0.1)"
      padding={3}
      spacing={4}
      minH="200px"
    >
      <Stack>
        <Text
          as="h3"
          fontSize="sm"
          fontWeight="bold"
          fontFamily="heading"
          lineHeight="20px"
          color="text.primary"
        >
          {item?.title}
        </Text>
        {/* <Text
          as="p"
          fontSize="xs"
          fontWeight="normal"
          lineHeight="17px"
          fontFamily="heading"
          color="text.secondary"
        >
          {item?.description}
        </Text> */}

        <Flex>
          <Text
            as="span"
            fontWeight={isEnterprisePlan ? 'semibold' : 'bold'}
            fontFamily="heading"
            lineHeight="22px"
            color="text.primary"
          >
            {isEnterprisePlan
              ? 'Request a quote'
              : `${item?.currency === 'USD' && '$'}${item?.price}`}
          </Text>

          {!isEnterprisePlan && (
            <Text
              as="span"
              fontFamily="heading"
              fontWeight="normal"
              fontSize="xs"
              lineHeight="21px"
              color="text.secondary"
              ml={1}
            >{`/contributor/mo`}</Text>
          )}
        </Flex>
      </Stack>

      <>
        {item?.key === currentPlan ? (
          <Button
            size="sm"
            variant="tertiary-disabled"
            _hover={{ userSelect: 'none' }}
            isDisabled={true}
          >
            Current Plan
          </Button>
        ) : isEnterprisePlan ? (
          <Box h="32px" />
        ) : (
          <Tooltip hasArrow label={tooltipLabel}>
            <Button
              disabled={!isAdmin}
              size="sm"
              variant="tertiary"
              onClick={handleStripeCheckout}
            >
              {`Get ${item?.title}`}
            </Button>
          </Tooltip>
        )}

        <Tooltip hasArrow label={tooltipLabel}>
          <Button
            disabled={!isAdmin}
            onClick={handleTalkToSalesClick}
            size="sm"
            variant="secondary"
          >
            Talk to Sales
          </Button>
        </Tooltip>
      </>

      <Stack>
        <Divider />
      </Stack>
      <Stack>
        <Text
          fontSize="xs"
          fontFamily="heading"
          lineHeight="17px"
          fontWeight="semibold"
          color="text.primary"
        >
          {item?.title === 'Enterprise'
            ? `Everything in Pro plan, plus`
            : "What's included"}
        </Text>

        {filteredFeatures.map((el: any, idx: number) => (
          <HStack key={`feature-${idx}`} spacing={1}>
            {el.enabled ? <TickIcon /> : <CrossIcon />}

            <Text
              fontSize="xs"
              fontFamily="heading"
              fontWeight="normal"
              lineHeight="17px"
              color="text.secondary"
            >
              {el.title}
            </Text>
          </HStack>
        ))}
      </Stack>
      {loading && <Loader />}
    </Stack>
  );
};

export default SubsPlanCard;
